import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function getHandOffTasksReducer(state = initialState.handOffTasks, action) {
	switch (action.type) {
		case types.GET_HAND_OFF_TASKS: {
			if (action.response) {
				return {
					...state,
					[action.apiKey]:
						action.response?.taskGroups && action.response.taskGroups[0] && action.response?.taskGroups[0]?.tasks
				};
			}
			return state;
		}
		case types.CLEAR_HAND_OFF_TASKS: {
			return {};
		}
		default:
			return state;
	}
}
